/* file description */
import React, { useState } from 'react';
import { Input, Space } from 'antd-mobile';
import styles from './index.module.less';
import { Form } from 'antd';

interface MobileInputPropsType {
  value?: string;
  placeholder?: string;
  onClick: () => void;
  disabled?: boolean;
}

export const MobileInput: React.FC<MobileInputPropsType> = ({
  value = '',
  placeholder = '暂无数据,请选择',
  onClick,
  disabled = false,
}) => {
  const { status } = Form.Item.useStatus();
  return (
    <Space
      align="center"
      className={disabled ? styles['diable-input'] : styles['nomal-input']}
      onClick={!disabled ? onClick : undefined}
      style={status == 'error' ? { border: '1px solid #ff4d4f' } : {}}
    >
      <Input value={value} placeholder={placeholder} readOnly disabled={disabled} style={{ width: '100%' }} />
    </Space>
  );
};
